import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosClient } from "../AxiosClient";

export const getFreeEventByStudentIdAsync = createAsyncThunk(
  "web/getFreeEventByStudentId",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/getFreeEventByStudentId?status=${payload.status}&day=${payload.day}&subjectId=${payload.subjectId}`,
      [],
      toolkit
    );
  }
);
